import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  activityRecommendationsApi,
  type AddRecommendationRequest,
  type RemoveRecommendationRequest,
  type UpdatePriorityRequest,
} from "../services/activity-recommendations";

export const useActivityRecommendations = ({ locale }: { locale: string }) => {
  return useQuery({
    queryKey: ["activity-recommendations", locale],
    queryFn: () =>
      activityRecommendationsApi.getAll({
        locale,
      }),
    enabled: !!locale,
  });
};

export const useAddActivityRecommendation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: AddRecommendationRequest) =>
      activityRecommendationsApi.add(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["activity-recommendations"],
      });
    },
  });
};

export const useRemoveActivityRecommendation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: RemoveRecommendationRequest) =>
      activityRecommendationsApi.remove(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["activity-recommendations"],
      });
    },
  });
};

export const useUpdateRecommendationPriority = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdatePriorityRequest) =>
      activityRecommendationsApi.updatePriority(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["activity-recommendations"],
      });
    },
  });
};
